<template>
  <el-table-column
    prop="gla_number.value"
    label="Főkönyvi szám"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.gla_number.value }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'gla_number.value',
  };
</script>
